import { Component, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { CompanionItem, MediaItem } from '../../../api/models';
import { TravelService } from '../../../api/services';
import { ConfirmationService, LazyLoadEvent, MessageService } from 'primeng/api';
import { Table, TableLazyLoadEvent } from 'primeng/table';
import { TravelControllerGetAllCompanions$Params } from '../../../api/fn/travel/travel-controller-get-all-companions';
import { AuthService } from '../../../guards/services/auth.service';

@Component({
  selector: 'app-modal-new-companion',
  templateUrl: './modal-new-companion.component.html',
  styleUrl: './modal-new-companion.component.scss'
})
export class ModalNewCompanionComponent {
  @ViewChild('dt1') table?: Table;

  imageChangedEvent: any = '';
  croppedImage: any = '';
  imageBlob?: Blob;
  img?: MediaItem;
  activeIndex = 0;
  companions: CompanionItem[] = [];
  totalRecords = 0;
  selected?: CompanionItem;
  companion_id?: number;

  frm: FormGroup = new FormGroup({
    name: new FormControl('', Validators.required),
    last_name: new FormControl('', Validators.required),
    description: new FormControl(''),
    email: new FormControl(''),
  })

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private sanitizer: DomSanitizer,
    private travelService: TravelService,
    public auth: AuthService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) {
    if(config.data.companion){
      this.selected = config.data.companion;
    }
   }

  getCompanions(event: TableLazyLoadEvent){
    const params: TravelControllerGetAllCompanions$Params = {
      limit: +event.rows!,
      skip: +event.first!,
    };
    this.travelService.travelControllerGetAllCompanions(params).subscribe({
      next: (res) => {
        this.companions = res.data.list;
        this.totalRecords = res.data.count;
      }
    })
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(
      (event).objectUrl!
    );
    this.imageBlob = event.blob!
    this.img = undefined;
    // event.blob can be used to upload the cropped image
  }
  imageLoaded(image: LoadedImage) {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }

  close() {
    this.ref.close();
  }

  saveNew(){
    if(this.companion_id){
      const frm = this.frm.value;
    this.travelService.travelControllerUpdateCompanion({
      id: this.companion_id,
      body: {
        description: frm.description,
        email: frm.email,
        last_name: frm.last_name,
        name: frm.name,
        picture: this.imageBlob
      }
    }).subscribe({
      next: (res) => {
        this.selected = res.data;
        this.ref.close(this.selected);
      }
    })
    }else{
      const frm = this.frm.value;
      this.travelService.travelControllerCreateCompanion({
        body: {
          description: frm.description,
          email: frm.email,
          last_name: frm.last_name,
          name: frm.name,
          picture: this.imageBlob
        }
      }).subscribe({
        next: (res) => {
          this.selected = res.data;
          this.ref.close(this.selected)
        }
      })
    }
  }

  saveCompanion(){
    this.ref.close(this.selected)
  }

  confirmDelete(id: number){
    this.confirmationService.confirm({
      message: 'Vuoi eliminare questo accompagnatore?',
      header: 'Eliminazione',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sì',
      rejectLabel: 'Annulla',
      acceptButtonStyleClass: 'bg-dialog p-button-sm',
      rejectButtonStyleClass: 'p-button-outlined p-button-sm mr-2',
      accept: () => {
        this.travelService.travelControllerDeleteCompanion({id}).subscribe({
          next: (res) => {
            this.messageService.add({
              severity: 'success',
              summary: 'Eliminazione',
              detail: "Accompagnatore eliminato con successo.",
            });
            this.getCompanions(this.table?.createLazyLoadMetadata());
          },
          error: (err) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Eliminazione',
              detail: "Impossibile eliminare l'accompagnatore.",
            });
          }
        })
      },
    });
  }

  updateCompanion(id: number){
    this.companion_id = id;
    this.activeIndex = 1;
    this.travelService.travelControllerGetCompanion({id}).subscribe({
      next: (res) => {
        this.frm.patchValue(res.data);
        this.img = res.data.profile_picture;
      }
    });
  }

}
